import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VenueBookings';

const VenueBookingApi: any = baseApi(endpoint);

export default VenueBookingApi;